import SignUpForm from './components/SignUpForm';
import Confirm from './components/Confirm';
import Location from './components/LocationHeader';
import React, {useState, useEffect} from 'react';
import "./App.css"
//Importing FullCalendar Module
import FullCalendar from '@fullcalendar/react';
import listPlugin from '@fullcalendar/list';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import 'bootstrap/dist/css/bootstrap.css';
import moment from 'moment-timezone';



function App() {

const[centers, setCenters] = useState([]);
const [accountId, setAccountId] = useState('');
const[formValidated, setFormValidated] = useState(false);
const[showConfirm, setShowConfirm] = useState(false);
const[showCalender, setShowCalendar] = useState(false);
const[selectedCenter, setSelectedCenter] = useState('');
const[timezone, setTimezone] = useState('');
const[selectedDate, setSelectedDate] = useState('');
const[multipleCenters, setmultipleCenters] = useState(false);

useEffect(()=>{
  fetchCenters();
}) 

async function fetchCenters () {
  console.log('Centers ' + centers.length); 
  if(centers.length < 1)
  {
    const api_call = await fetch(`https://salesforceservices.azurewebsites.net/api/getavailablecenters?code=DGv_gPupBIb0NJ67dxUO4dylSha8b0Kq-oE6GgrWzhqaAzFuEoqNEQ==&company=trusmile`);
    console.log(api_call);
    const data = await api_call.json();
    if(data)
    {
      setCenters(data);
      console.log('Centers are' + JSON.stringify(centers));
    }
    console.log(centers.length)
    if(centers.length>1)
    {
      setmultipleCenters(true);
    }
  }
  if(centers.length === 1)
  {
    setSelectedCenter(centers[0].Id);
    setTimezone(centers[0].Time_zone__c);
    console.log('Selected Center is:' + selectedCenter);
  }
    }

    function eventMount(args)
    {
      args.event.setProp('title','<b>Available</b>');
      args.el.querySelector('.fc-list-event-title').innerHTML = '<button type="button" class="gform_button button" >Schedule</button>';
    }
    async function eventClick(args)
    {
     setSelectedDate(moment.tz(args.event.start, timezone).format('dddd  MMMM DD, YYYY') + ' at ' + moment.tz(args.event.start,timezone).format('H:mm A'));
     console.log(args.event.start);
     console.log(args.event.id);
     const api_call = await fetch(`https://salesforceservices.azurewebsites.net/api/scheduleappointment?code=VLtqMrE-xhaC1z_An-lzAo2o5nlI8Wy_4myfGb7nYf1XAzFu7vt-WA==&company=trusmile&e=${args.event.id}&a=${accountId}`);
     window.location.href = "https://trusmileimplants.com/schedule-thank-you/";
    }

  return (
   <div className="App">
   <div className="row">
   <div className="col-md-12">
   {showConfirm ? <Confirm date={selectedDate}></Confirm>
        : null }
   {!formValidated ? <SignUpForm setAccountId = {setAccountId} setFormValidated = {setFormValidated} setShowCalendar = {setShowCalendar}></SignUpForm> : null}
    {multipleCenters ? <Location centers = {centers} setSelectedCenter = {setSelectedCenter} setTimezone = {setTimezone} setFormValidated = {setFormValidated}></Location> : null}
   </div>
   <div className="col-md-12">
   {showCalender ? <FullCalendar
          plugins={[ listPlugin,momentTimezonePlugin ]}
          initialView="listWeek"
          navLinks = {false}
          events = {'https://salesforceservices.azurewebsites.net/api/getavailableevents?code=eWwDcmjZHKIKTipaiIpoRT75fcgag-DyrNISvDHzMYh2AzFuuQoqAA==&company=trusmile&centerId=' + selectedCenter + '&room=Room 2' }
          timeZone= {timezone}
          height= 'auto'
          buttonIcons = "false"
          displayEventEnd = {false}
          titleFormat = {{month: 'long', day: 'numeric' }}
          eventDidMount = {eventMount}
          eventClick = {eventClick}
        />: null }
</div>
</div>
</div>
  );  
}

export default App;